'use client';

import { UiKitLabelBase } from '@/fo/ui/kit/label/base';

import { Bonuses } from '../components/Bonuses/Bonuses';

import { styles } from './UiLoyaltyInformerCount.styles';

export interface UiLoyaltyInformerCountProps {
  className?: string;
  bonuses: number;
  bonusesMax: number;
  isAuthorized?: boolean;
  label?: string;
  showLogin?: boolean;
  size?: 'xs' | 's';
}

export function UiLoyaltyInformerCount({
  className,
  bonuses,
  bonusesMax,
  label,
  isAuthorized,
  showLogin,
  size = 's'
}: UiLoyaltyInformerCountProps) {
  const slots = styles();

  return (
    <div className={slots.base({ className })}>
      <Bonuses
        showLogin={showLogin}
        bonuses={bonuses}
        bonusesMax={bonusesMax}
        isAuthorized={isAuthorized}
        size={size}
      />
      {label && <UiKitLabelBase color="orange">{label}</UiKitLabelBase>}
    </div>
  );
}
